import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import { Dispatch, FC, SetStateAction } from 'react';
import { Class } from '../../models/Class';
import { DropdownItemModel, FormState } from '../../pages/SingleUnit';
import { formatClassDisplayName } from '../../utils/formatClassDisplayName';
import { sortClassesList } from '../../utils/sortClassesList';

interface Props {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  classes: Class[];
  standards: DropdownItemModel[];
  showClasses: boolean;
}

const UnitsOptionalFilters: FC<Props> = ({ form, setForm, classes, standards, showClasses }) => {
  const classItemTemplate = (cls: Class) => (cls ? formatClassDisplayName(cls) : '');

  if (!showClasses && !standards.length) return null;

  return (
    <div className="nc_optional-filters">
      <span className="nc_optional-filters__title">Optional filters</span>

      {showClasses && (
        <label className="nc_optional-filter">
          <span className="nc_optional-filter__label">Classes:</span>
          <MultiSelect
            value={form.class}
            options={sortClassesList(classes)}
            optionLabel="sectionName"
            onChange={(event: MultiSelectChangeEvent) => setForm(prev => ({ ...prev, class: event.value }))}
            itemTemplate={classItemTemplate}
            selectedItemTemplate={classItemTemplate}
            selectionLimit={1}
            filter
            placeholder="All classes"
            disabled={!form.unit}
          />
        </label>
      )}

      <label className="nc_optional-filter">
        <span className="nc_optional-filter__label">Standards:</span>
        <MultiSelect
          value={form.standards}
          options={standards}
          optionLabel="label"
          optionValue="value"
          onChange={(event: MultiSelectChangeEvent) => setForm(prev => ({ ...prev, standards: event.value }))}
          filter
          placeholder="All"
          disabled={!standards.length}
        />
      </label>
    </div>
  );
};

export default UnitsOptionalFilters;
